import { useEffect, useState } from 'react'

import { http } from '@itau-loans-www/services'
import auth from '@itau-loans-www/services/http/auth'

const useDocumentation = (formProps, initialValues) => {
  const [loading, setLoading] = useState(true)
  const [statesOptions, setStatesOptions] = useState()
  const [agenciesOptions, setAgenciesOptions] = useState()

  useEffect(() => {
    auth({}).then(async () => {
      http.formalization.getStates().then((data) => {
        const options = data.map((item) => {
          if (initialValues?.document_state?.value === item['state_uf']) {
            formProps.setValue('state', item['state_name'])
          }

          return {
            label: item['state_name'],
            value: item['state_id'],
            state_uf: item['state_uf']
          }
        })

        setStatesOptions(options)
      })

      http.formalization.getIdentityAgencies().then((data) => {
        const options = data.map((item) => {
          if (
            initialValues?.document_issuer_id?.value ===
            item['identity_agency_id']
          ) {
            formProps.setValue('document_issuer', item['identity_agency_name'])
          }

          return {
            label: item['identity_agency_name'],
            value: item['identity_agency_id']
          }
        })

        setAgenciesOptions(options)
        setLoading(false)
      })
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues])

  return { statesOptions, agenciesOptions, loading }
}

export default useDocumentation
